import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";
import { useHaptics } from "@/modules/haptics/useHaptics/useHaptics";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    hapticsDisabled?: boolean;
  }
>(({ className, hapticsDisabled, onCheckedChange, ...props }, ref) => {
  const { selection } = useHaptics();
  return (
    <CheckboxPrimitive.Root
      className={cn(
        "-ring-offset-1 data-[state=checked]:bg-newTheme-peach-light peer h-6 w-6 shrink-0 appearance-none rounded border border-none  border-primary  ring-1 ring-light-grey focus:ring focus:!ring-blue-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-red aria-invalid:ring-red aria-invalid:placeholder:text-red data-[state=checked]:text-black",
        className
      )}
      ref={ref}
      onCheckedChange={(v) => {
        selection({ disabled: hapticsDisabled }).catch(() => undefined);
        onCheckedChange?.(v);
      }}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        <Check className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
